import { render, staticRenderFns } from "./Marrow.vue?vue&type=template&id=ede3b74a&"
import script from "./Marrow.vue?vue&type=script&lang=js&"
export * from "./Marrow.vue?vue&type=script&lang=js&"
import style0 from "./Marrow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports